import React from 'react'
import './TimeTracker.css'
const TimeTracker = () => {
  return (
    <div>
      <h1>TimeTracker</h1>
    </div>
  )
}

export default TimeTracker
